// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyCkWvJ10kr3N7qzDJI4iADb8HSIjhZUKyw",
    authDomain: "lcarchivewebsite.firebaseapp.com",
    databaseURL: "https://lcarchivewebsite.firebaseio.com",
    projectId: "lcarchivewebsite",
    storageBucket: "lcarchivewebsite.appspot.com",
    messagingSenderId: "718129445517",
    appId: "1:718129445517:web:6858ac1e8e3a62397800c4",
    measurementId: "G-6WR9RG3DXX"
  }
};



/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
